import React, { useRef, useState } from 'react';
import { isArray, isEmpty, find } from 'lodash';
import axios from 'axios';

import { CustomFormModalContext } from '../../utils/contexts';
import { CustomFormPartTypes } from '../../utils/types';
import { Container, Modal, Content, FormRow, Button } from '../../styles/modals/generic-modal';
import Header from './parts/modal-header';
import StarRatingInput from './parts/star-rating-input';
import RadioGroup from './parts/radio-group';
import NotifyBox from './parts/notify-box';

function generateCustomFormPart(configData, index = null) {
  let children = null;

  if (configData.partType === CustomFormPartTypes.para) {
    children = [
      <p key={`custom_form_part_p_${index}`} >{configData.content}</p>
    ];
  }
  else if (configData.partType === CustomFormPartTypes.input) {
    children = [
      <label key={`custom_form_part_input_label_${index}`} htmlFor={configData.name} >{configData.label}</label>,
      <br key={`custom_form_part_input_br_${index}`} />,
      <input key={`custom_form_part_input_${index}`} name={configData.name} type={configData.type} required={configData.required} />
    ];
  }
  else if (configData.partType === CustomFormPartTypes.textarea) {
    children = [
      <label key={`custom_form_part_textarea_label_${index}`} htmlFor={configData.name} >{configData.label}</label>,
      <br key={`custom_form_part_textarea_br_${index}`} />,
      <textarea key={`custom_form_part_textarea_${index}`} name={configData.name} required={configData.required} />
    ];
  }
  else if (configData.partType === CustomFormPartTypes.starRating) {
    children = [
      <StarRatingInput />
    ];
  }
  else if (configData.partType === CustomFormPartTypes.radioChoice) {
    children = [
      <label key={`custom_form_part_radio_group_label_${index}`} htmlFor={configData.name} >{configData.label}</label>,
      <br key={`custom_form_part_radio_group_br_${index}`} />,
      <RadioGroup key={`custom_form_part_radio_group_${index}`} groupName={configData.name} options={configData.options} required={configData.required} />
    ];
  }

  if (children) {
    return <FormRow key={`custom_form_part_${index}`} >
      {children}
    </FormRow>
  }
}

function getSubmitTextFromConfig(partsConfig, fallback = 'Submit') {
  return find(partsConfig, { partType: CustomFormPartTypes.submitTextOverride }) || fallback;
}

export default function CustomFormModal(props) {

  const [isSubmitting, setIsSubmitting] = useState(false);
  const controlRef = useRef(null);

  const handleFormSubmit = (e, action, method, postSubmit) => {
    e.persist();
    e.preventDefault();

    if (action) {
      setIsSubmitting(true);
      const formData = new FormData(e.target);
      const data = {};

      for (const entry of formData.entries()) {
        data[entry[0]] = entry[1];
      }

      axios({
        url: action,
        method,
        data: data,
      })
      .then((response) => {
        setIsSubmitting(false);
        controlRef.current.show();

        setTimeout(() => {
          controlRef.current.hide();
          postSubmit();
        }, 3000);
      })
      .catch((err) => {
        console.error("Submission ERROR:", err);
      });
    }
  };

  return (
    <CustomFormModalContext.Consumer>
      {
        ({ isOpen, title, action, method, partsConfig, setIsOpen }) => {

          if (isOpen) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', (e) => {
              e.preventDefault();
              setIsOpen(false)
            });
          }

          return <Container visible={isOpen} className="bg" onClick={(e) => e.target.classList.contains('bg') && setIsOpen(false)}>
            <Modal>
              <Header onCloseClick={() => setIsOpen(false)} />
              <Content className="pad scrollable" style={{ maxHeight: '75vh' }} >
                {title && <h3>{title}</h3>}
                <form
                  className="comment-form"
                  onSubmit={(e) => handleFormSubmit(e, action, method, () => setIsOpen(false))}
                >
                  {
                    isArray(partsConfig)
                    && !isEmpty(partsConfig)
                    && partsConfig
                      .filter((partConfig) => partConfig.type !== CustomFormPartTypes.submitTextOverride)
                      .map((config, index) => generateCustomFormPart(config, index))
                  }
                  <FormRow>
                      <NotifyBox control={(control) => controlRef.current = control} >
                        Thank you for your submission. We'll get back to you soon.
                      </NotifyBox>
                    <div className="left-spacer" ></div>
                    <div className="right-spacer" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingTop: '20px' }} >
                      <Button type="submit" disabled={isSubmitting} >{getSubmitTextFromConfig(partsConfig)}</Button>
                    </div>
                  </FormRow>
                </form>
              </Content>
            </Modal>
          </Container>
        }

      }
    </CustomFormModalContext.Consumer>
  );
}